import React, { FormEvent, useCallback } from "react";
import useApi from "../../hooks/useApi";
import { SubmitButton } from "../../Korbantech/components/Buttons/SubmitButton";
import { TextInput } from "../../Korbantech/components/Inputs/TextInput";
import { Label } from "../../Korbantech/components/Label";
import { Trail } from "../../types/Trail";

export const NameFields = ({ trail }: Props) => {


    const api = useApi();

   
    const handleUpdate = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        if (!trail) return
        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)
        data.append('_method', 'PATCH')
        return await api.post(`/admin/trails/${trail.id}`, data).then(res => {
            window.location.reload();
        }).catch(console.log)


    }, [api, trail])

    return (
        <>
            {trail && (
                <form onSubmit={handleUpdate}>
                    <Label>
                        Nome da trilha
                        <TextInput
                            name="name"
                            className="bg-gray-100 rounded border border-gray-600 text-gray-700"
                            defaultValue={trail ? trail.name : ""}
                        />
                    </Label>
                    <div className="flex flex-col items-end mt-2">
                            <div className="w-5/12">
                                <SubmitButton value="Alterar nome" />
                            </div>
                    </div>
                    
                </form>
            )}
            {!trail && (
                <Label>
                    Nome da trilha
                    <TextInput
                        name="name"
                        className="bg-gray-100 rounded border border-gray-600 text-gray-700"
                    />
                </Label>
            )}
        </>
    );
};

interface Props {
    trail?:Trail
}
